(function () {
  const prefersReducedMotion =
    typeof window !== 'undefined' &&
    window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function enhanceImage(img) {
    if (!img || img.dataset.twImgEnhanced === '1') return;
    img.dataset.twImgEnhanced = '1';

    // Only apply to lazy images (avoid affecting hero/LCP images).
    const isLazy = (img.getAttribute('loading') || '').toLowerCase() === 'lazy';
    if (!isLazy) return;

    img.classList.add('tw-img-skeleton');

    function done() {
      img.classList.add('tw-img-skeleton--loaded');
    }

    if (img.complete && img.naturalWidth > 0) {
      done();
      return;
    }

    img.addEventListener('load', done, { once: true });
    img.addEventListener(
      'error',
      function () {
        // On error, remove skeleton to avoid permanent shimmer.
        img.classList.add('tw-img-skeleton--loaded');
      },
      { once: true }
    );

    // Reduced motion: skip fade/shimmer quickly.
    if (prefersReducedMotion) {
      img.classList.add('tw-img-skeleton--reduce');
    }
  }

  function init(root) {
    (root || document).querySelectorAll('img').forEach(enhanceImage);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  // Shopify theme editor / dynamic injection.
  document.addEventListener('shopify:section:load', (e) => init(e && e.target ? e.target : document));
})();

